import * as classNames from 'classnames';
import * as React from 'react';

import * as Bulma from './../../bulma';
import { withHelpersModifiers } from './../../bulma';

export interface Navbar<T> extends Bulma.Tag, React.HTMLProps<T> {
    isTransparent?: boolean;
}

export function Navbar({tag= 'nav', isTransparent, ...props}: Navbar<HTMLElement>) {
    const className = classNames(
        'navbar',
        {
            'is-transparent': isTransparent,
        },
        props.className,
    );

    return React.createElement(tag, { ...props, className });
}

const HOC = /*@__PURE__*/withHelpersModifiers(Navbar);
export default HOC;



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.tsx